import React from "react";
import "./About.css";
import Navbar from "../components/Navbar/Navbar";
import "./About.css";
import { Card, Button } from "react-bootstrap";

function About() {
  return (
    <>
      <Navbar />
      <div className="container text-start">
        <h3>About this project</h3>
        <hr />
        <div className="row">
          <div className="col-12">
            <p className="about-text">
              Project carried out to apply what was learned about React, consume
              APIs, deployment. These are some of the topics learned and put
              into practice in the Hack Academy Coding Bootcamp.
            </p>
            <img
              className="img-rounded"
              style={{
                position: "relative",
                width: "200px",
                height: "200px",
                overflow: "hidden",
                borderRadius: "50%",
              }}
              src={"../profile.jpg"}
              alt="Stephanie Esquire"
            />
            <p className="about-text mt-2">
              My name is Stephanie Esquire. I have extensive experience in
              various areas, both professionally and academically. Each of them
              has contributed to my personal and professional development. I
              handle several technologies: JavaScript, Node.js, Express, SQL,
              MongoDB, Passport.js, React. APIs, Git and Github. Enthusiasm,
              empathy and optimism are my pillars.
            </p>
          </div>
        </div>
        <hr />
      </div>
    </>
  );
}

export default About;
